import React, { useMemo } from 'react'
import { EnrollmentBill } from '../../../../swagger'
import AnnualEnrollmentPaymentCard from '../AnnualEnrollmentPaymentCard'
import { Box } from '@mui/material'
import { ParentInvoiceCard } from '../ParentInvoiceCard'
import { FetchBillingResponse } from '../../../../swagger'
import { Payment, PaymentMade } from '../../../Interfaces/Payment'

interface ParentBillingViewProps {
  billingData: FetchBillingResponse
  triggerRefetch: () => void
  achDiscount: string
}

const ParentBillingView: React.FC<ParentBillingViewProps> = ({
  billingData,
  triggerRefetch,
  achDiscount,
}) => {
  const enrollmentBill: EnrollmentBill | undefined =
    billingData?.enrollment?.owed

  const enrollmentPaymentHistory: Payment[] = useMemo(() => {
    if (!billingData?.enrollment) {
      return []
    }

    return (
      billingData.enrollment.history?.map((enrollmentHistory) => {
        const paymentHistory: Payment = {
          ...enrollmentHistory,
          paymentsMade: enrollmentHistory.enrollmentPayments.map(
            (enrollmentPayment) => {
              const paymentMade: PaymentMade = {
                ...enrollmentPayment,
                paymentKey: enrollmentPayment.enrollmentPaymentKey,
              }
              return paymentMade
            }
          ),
        }
        return paymentHistory
      }) ?? []
    )
  }, [billingData?.enrollment])

  const showEnrollmentPaymentCard =
    enrollmentBill || enrollmentPaymentHistory.length > 0

  return (
    <>
      {showEnrollmentPaymentCard && (
        <AnnualEnrollmentPaymentCard
          enrollmentPaymentHistory={enrollmentPaymentHistory}
          enrollmentBill={enrollmentBill}
          refetch={triggerRefetch}
          achDiscount={achDiscount}
        />
      )}
      <Box mt={11}>
        <ParentInvoiceCard parentInvoices={billingData?.parentInvoices ?? []} />
      </Box>
    </>
  )
}

export default ParentBillingView
